<script setup lang="ts">
import { useRouter } from 'vue-router';
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { TrackEventCategory } from '@/application/utils/tracking/events';

defineProps<{
  bankAccessId: string,
  bankAccountId: string,
}>();

const router = useRouter();

async function onInitSepaSingleTransfer(e: CustomEvent) {
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'initSepaSingleTransfer' });
  await openRegprotect(e);
}

async function openRegprotect(e: CustomEvent) {
  const { sessionLink } = e.detail;
  await router.push({ path: '/banking/regprotect', query: { sessionLink } });
}

async function onOpenTransaction(e: CustomEvent) {
  const { bankAccessId, bankAccountId, transactionId } = e.detail;
  await router.push(`/banking/${bankAccessId}/account/${bankAccountId}/transaction/${transactionId}`);
}

async function onGoBack(event: CustomEvent) {
  event.preventDefault();
  await router.push('/banking');
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <!-- eslint-disable vue/attribute-hyphenation -->
    <ba-account-detail
      :token="token"
      :bankAccessId="bankAccessId"
      :bankAccountId="bankAccountId"
      @openTransaction="onOpenTransaction"
      @initSepaSingleTransfer="onInitSepaSingleTransfer"
      @openRegprotect="openRegprotect"
      @emitError="(e) => onEmitError(e, 'ba-account-detail')"
      @goBack="onGoBack"
    />
  </BankingWrapper>
</template>
